import React from "react";
import { Phone } from "lucide-react";
import { BRAND } from "@/lib/brand";

/**
 * Floating "Call Now" button — visible only on mobile (<768px).
 * Sits in the bottom-right corner of every public page.
 */
export default function CallNowFab() {
  return (
    <a
      href={BRAND.phoneHref}
      data-testid="call-now-fab"
      aria-label={`Call ${BRAND.phone}`}
      className="md:hidden fixed bottom-5 left-5 z-40 group"
    >
      {/* Soft pulsing ring */}
      <span className="absolute inset-0 rounded-full bg-[var(--brand-gold)] opacity-50 animate-ping" />
      <span className="relative flex items-center gap-2 bg-[var(--brand-gold)] text-white font-bold tracking-wide pl-3.5 pr-5 py-3.5 rounded-full shadow-lg shadow-[var(--brand-gold)]/40 border-2 border-white">
        <Phone className="w-5 h-5" />
        <span className="text-sm" style={{ fontFamily: "Outfit" }}>Call Now</span>
      </span>
    </a>
  );
}
